import { useEffect } from 'react';
import NProgress from 'nprogress';
import { keyframes } from '@mui/system';
import { Box, Typography } from '@mui/material';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

function SuspenseLoader() {
  useEffect(() => {
    NProgress.configure({ showSpinner: false });
    NProgress.start();

    return () => {
      NProgress.done();
    };
  }, []);

  return (
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 9999,
          backdropFilter: 'blur(4px)',
          backgroundColor: 'rgba(0, 0, 0, 0.4)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
        }}
      >
        <Box
          sx={{
            textAlign: 'center',
          }}
        >
          {/* Spinner */}
          <Box
            sx={{
              width: 60,
              height: 60,
              margin: '0 auto 24px',
              position: 'relative',
              '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                borderRadius: '50%',
              },
              '&::after': {
                content: '""',
                position: 'absolute',
                top: -3,
                left: -3,
                right: -3,
                bottom: -3,
                borderRadius: '50%',
                border: '3px solid transparent',
                borderTopColor: 'primary.main',
                animation: `${spin} 1s linear infinite`,
              },
            }}
          />

          <Typography variant="h6"  sx={{ fontWeight: 'bold'}}>
            EthioLiq is Loading...
          </Typography>
        </Box>
      </Box>
  );
}

export default SuspenseLoader;